import { ApolloProvider } from '@apollo/client';
import '@koalafi/component-library/tailwind.min.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import client from './apollo';
import App from './App';
import CommonContainer from './components/common-container/common-container';
import CustomErrorBoundary from './components/customErrorBoundary/custom-error-boundary';
import './index.css';
import './segmentScript';
import './tailwind.css';
import './i18n';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      {/* <Suspense fallback={<PageLoader data-testid="page-loader" />}> */}
      {/* Common container provides styling for the entire application - necessary to make sure any loaders/custom error boundaries live inside our app (modal or full screen) */}
      <CommonContainer>
        {/* pass in vanilla track and page functions because it's too early to configure a default payload.  identify is a noop since the component does not use it */}
        <ErrorBoundary
          FallbackComponent={(error) => (
            <CustomErrorBoundary
              orderId=""
              error={error}
              dealer={undefined}
              role={undefined}
              track={window.analytics.track}
              page={window.analytics.page}
              identify={() => {}}
            />
          )}
        >
          <App />
        </ErrorBoundary>
      </CommonContainer>
      {/* </Suspense> */}
    </ApolloProvider>
  </React.StrictMode>,
);
